import styled from "styled-components";
import { WrapperContainer } from "../../../../../../../components";
import { PagesWrapper } from "../../../../../../../components/PageSelector/styled";

export const SimpleListWrapper = styled(WrapperContainer)`
  padding-bottom: 24px;

  ${PagesWrapper} {
    margin-top: unset;
    border-bottom: unset;
  }
`;
